import { lazy, Suspense } from 'react'
import { BrowserRouter, HashRouter, Navigate, Route, Routes } from 'react-router-dom'

import { UserLoginPage } from '@/pages/login/LoginPages'
import { CasdoorCallbackPage } from '@/pages/login/CasdoorCallbackPage'
import { RequireUser } from './RequireUser'

const HomePage = lazy(() => import('@/pages/home/HomePage'))
const TasksPage = lazy(() => import('@/pages/tasks/TasksPage'))
const TaskDetailPage = lazy(() => import('@/pages/task-detail/TaskDetailPage'))
const CreditsPage = lazy(() => import('@/pages/credits/CreditsPage'))
const PricingPage = lazy(() => import('@/pages/pricing/PricingPage'))
const OrdersPage = lazy(() => import('@/pages/orders/OrdersPage'))
const CheckoutPage = lazy(() => import('@/pages/checkout/CheckoutPage'))
const PaymentResultPage = lazy(() => import('@/pages/payment-result/PaymentResultPage'))
const DeveloperPage = lazy(() => import('@/pages/developer/DeveloperPage'))
const CliAuthorizePage = lazy(() => import('@/pages/cli-authorize/CliAuthorizePage'))
const PrivacyPolicyPage = lazy(() => import('@/pages/legal/PrivacyPolicyPage'))
const TermsOfServicePage = lazy(() => import('@/pages/legal/TermsOfServicePage'))
const NotFoundPage = lazy(() => import('@/pages/not-found/NotFoundPage'))

export function AppRoutes() {
  return (
    <Suspense
      fallback={
        <main className="grid min-h-[50vh] place-items-center text-muted-foreground">
          正在加载…
        </main>
      }
    >
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/login" element={<UserLoginPage />} />
        <Route path="/auth/casdoor/callback" element={<CasdoorCallbackPage />} />
        <Route element={<RequireUser />}>
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/tasks/:id" element={<TaskDetailPage />} />
          <Route path="/credits" element={<CreditsPage />} />
          <Route path="/developer" element={<DeveloperPage />} />
          <Route path="/cli/authorize" element={<CliAuthorizePage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/payment-result" element={<PaymentResultPage />} />
        </Route>
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Suspense>
  )
}

export function AppRouter() {
  const Router = window.location.protocol === 'file:' ? HashRouter : BrowserRouter
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRoutes />
    </Router>
  )
}
